/*
 * The Company tool  ·  assets/the-company.js
 *
 * Powers the "Gather a Company" feature inside The DM's Satchel.
 *   1. DM picks a scenario (eight types of group).
 *   2. DM picks a size (2 to 5 members).
 *   3. We pull that many characters from the Hall at random.
 *   4. The Cloudflare worker (POST /company) writes a ready-to-use
 *      NPC group: name, hook, member roles, bonds, DM hook.
 *   5. Result view shows character images and offers a PDF export
 *      the DM can print or drop on their screen at the table.
 *
 * Lives outside sections/hall-of-heroes.liquid so the section file
 * stays under Shopify's 256 KB limit.
 */

(function(){
  'use strict';

  var SUPABASE_URL='https://obadckrukccwkjgpbsxa.supabase.co/';
  var SUPABASE_ANON_KEY='sb_publishable_4DntR53dZydUazuyuPI3YQ_zg69PLYZ';
  var COMPANY_WORKER_URL='https://quest-ai.fondlyframed.workers.dev/company';

  var _supa=null;
  function supa(){
    if(_supa)return _supa;
    if(!window.supabase||!window.supabase.createClient){
      console.error('[Company] supabase-js not loaded yet');
      return null;
    }
    _supa=window.supabase.createClient(SUPABASE_URL,SUPABASE_ANON_KEY);
    return _supa;
  }

  /* ============ STATE ============ */
  /* Current picked scenario and latest generated group.
     Reset every time we open the modal fresh. */
  var currentScenario=null;
  var currentCompany=null;
  var currentCharacters=null;

  /* ============ SCENARIOS ============ */
  /* R63: Trimmed to four hand-picked archetypes per product spec.
     The strategy: keep the presets small + sharp so they read as
     curated, and put all the open-ended power into the For Your Own
     custom path (FF Portrait owners). Order chosen so the most
     useful "drop into a session tonight" archetypes lead. */
  var SCENARIOS=[
    {
      id:'smugglers',
      label:'Smuggling Crew',
      icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="4.5" r="1.8"/><rect x="3.5" y="9" width="14" height="11" rx="1"/><path d="M3.5 13.5h14M10.5 9v11"/></svg>',
      blurb:'Contraband runners with a job that just went sideways.',
      vibe:'A tight smuggling outfit moving something they probably shouldn\'t. Paranoid, loyal to each other, loose with strangers. The job has just gone wrong and they need the party\'s help or the party\'s silence.'
    },
    {
      id:'cult',
      label:'Cult Cell',
      icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19L12 4l9 15z"/><circle cx="12" cy="14" r="2.2"/><circle cx="12" cy="14" r="0.6" fill="currentColor"/></svg>',
      blurb:'True believers hiding under normal faces.',
      vibe:'A cell of a wider cult. They look like a baker, a clerk, a sellsword, a mourner until they don\'t. One of them is having doubts.'
    },
    {
      id:'rivals',
      label:'Rival Adventurers',
      icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4l11 11M4 6.5V4h2.5M20 20l-2-2M17.5 20H20v-2.5"/><path d="M20 4L9 15M17.5 4H20v2.5M4 20l2-2M4 17.5V20h2.5"/></svg>',
      blurb:'Another party, same dungeon, different agenda.',
      vibe:'A rival adventuring party working the same job as the PCs. Competent, cocky, not necessarily hostile. They think they\'re the real heroes of the story.'
    },
    {
      id:'regulars',
      label:'Tavern Regulars',
      icon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 9h10v10a2 2 0 01-2 2H7a2 2 0 01-2-2z"/><path d="M15 11h2.5a2 2 0 012 2v2a2 2 0 01-2 2H15"/><path d="M6 9c0-1.2 1-2 2.2-2h3.6c1.2 0 2.2 0.8 2.2 2"/><path d="M7.5 7c0-0.6 0.6-1 1.2-1s1.2 0.4 1.2 1M11 7c0-0.6 0.6-1 1.2-1s1.2 0.4 1.2 1"/></svg>',
      blurb:'The local bar\'s stable of faces who always show up.',
      vibe:'The regulars at a specific tavern: the one who always sits in the corner, the one who starts fights, the one who breaks them up, the one who\'s just arrived. They have a history with each other the party won\'t fully understand.'
    }
  ];

  /* ============ SIZES (deprecated R63) ============
     Kept as an empty array for any legacy callers. The size picker UI
     was removed: company size now equals the chosen party\'s member
     count. Anyone reaching this surface should already have a party
     pinned via __hohPendingPartyRun. */
  var SIZES=[];

  /* ============ UTILS ============ */
  function $(id){return document.getElementById(id);}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');}
  function shuffle(a){for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t;}return a;}
  function firstLetter(s){var t=String(s||'').trim();return t?t.charAt(0).toUpperCase():'?';}

  /* Gender-neutral pass for AI-generated narrative text (role, bond,
     dm_hook, hook). The Company\'s server-side worker can produce
     gendered prose ("She walks the deck...", "His coin...") which the
     hall is meant to keep neutral so any character reads the role as
     theirs. We word-boundary-replace common gendered pronouns with
     they/them equivalents and a few clearly gendered nouns with
     neutral substitutes. Capitalization is preserved by running both
     cases through the same regex pair. "Her" maps to "their" because
     character descriptions are dominantly possessive ("her coin" →
     "their coin"); object-position uses ("saw her" → "saw their")
     read slightly off but the trade-off is worth gender-neutrality. */
  function neutralize(text){
    if(!text) return text;
    var s = String(text);
    var rules = [
      [/\bhe\b/g, 'they'],     [/\bHe\b/g, 'They'],
      [/\bshe\b/g, 'they'],    [/\bShe\b/g, 'They'],
      [/\bhis\b/g, 'their'],   [/\bHis\b/g, 'Their'],
      [/\bher\b/g, 'their'],   [/\bHer\b/g, 'Their'],
      [/\bhim\b/g, 'them'],    [/\bHim\b/g, 'Them'],
      [/\bhers\b/g, 'theirs'], [/\bHers\b/g, 'Theirs'],
      [/\bhimself\b/g, 'themself'], [/\bHimself\b/g, 'Themself'],
      [/\bherself\b/g, 'themself'], [/\bHerself\b/g, 'Themself'],
      [/\bman\b/g, 'one'],     [/\bMan\b/g, 'One'],
      [/\bwoman\b/g, 'one'],   [/\bWoman\b/g, 'One'],
      [/\bguy\b/g, 'one'],     [/\bGuy\b/g, 'One'],
      [/\bgirl\b/g, 'one'],    [/\bGirl\b/g, 'One'],
      [/\bboy\b/g, 'one'],     [/\bBoy\b/g, 'One'],
      [/\blady\b/g, 'one'],    [/\bLady\b/g, 'One'],
      [/\bgentleman\b/g, 'one'], [/\bGentleman\b/g, 'One']
    ];
    for(var i=0;i<rules.length;i++) s = s.replace(rules[i][0], rules[i][1]);
    return s;
  }

  function showView(name){
    ['picker','size','custom','loading','result','error','locked','soon'].forEach(function(v){
      var el=$('hoh-company-'+v);
      if(el)el.style.display=(v===name)?'':'none';
    });
    /* R104 / R111-A: Toggle modal-level class for the For Your Own
       rainbow theme. R104 originally only set this on the builder
       view, which left loading + result views in the maroon theme.
       Now: the class follows the SCENARIO (custom = rainbow), not
       the current view. Builder, loading, and result all stay rainbow
       end-to-end for a coherent For Your Own flow. The picker view
       resets the class because no scenario is selected yet. */
    var modal = $('hoh-company-modal');
    if(modal){
      var isCustomScenario = (name === 'custom') ||
        (currentScenario && currentScenario.id === 'custom' &&
         (name === 'loading' || name === 'result'));
      if(isCustomScenario){ modal.classList.add('hoh-company-modal-custom'); }
      else { modal.classList.remove('hoh-company-modal-custom'); }
    }
  }

  /* ============ LOADING ANIMATION ============
     Five rotating stage-messages driven on a timer, synced with
     the progress bar filling underneath. Ticker slots are rendered
     once per loading view, sized to the chosen party size.

     Two message sets:
     - LOADING_STAGES_HALL: when pulling random heroes from the
       community Hall (main hall flow).
     - LOADING_STAGES_PARTY: when running an exact-member party
       (Run This Party / Saved Company > Run Again). The first line
       speaks to the user's own crew, not a random pull. */
  var LOADING_STAGES_HALL=[
    {text:'Pulling faces from the Hall...', sub:'Scanning every character card.'},
    {text:'Reading their stories...', sub:'Looking for bonds, rivalries, and debts.'},
    {text:'Setting the scene...', sub:'Deciding where this company meets.'},
    {text:'Naming the group...', sub:'Something a DM can actually say out loud.'},
    {text:'Drafting the DM hook...', sub:'The reason the party crosses their path.'}
  ];
  var LOADING_STAGES_PARTY=[
    {text:'Calling your crew together...', sub:'Reading what they bring to this scenario.'},
    {text:'Reading their stories...', sub:'Looking for bonds, rivalries, and debts.'},
    {text:'Setting the scene...', sub:'Deciding where your company meets.'},
    {text:'Naming the group...', sub:'Something a DM can actually say out loud.'},
    {text:'Drafting the DM hook...', sub:'The reason this scenario pulls them in.'}
  ];
  var loadingStageTimer=null;

  function renderLoadingSlots(size){
    var host=$('hoh-company-loading-slots');
    if(!host)return;
    var n=Math.max(2,Math.min(6,size||3));
    var html='';
    for(var i=0;i<n;i++)html+='<div class="hoh-company-loading-slot"></div>';
    host.innerHTML=html;
  }

  function startLoadingMessages(scenario,size){
    stopLoadingMessages();
    var txt=$('hoh-company-loading-text');
    var sub=$('hoh-company-loading-sub');
    if(!txt||!sub)return;
    /* Detect whether this run is from the user's own party (exact
       mode) so we use party-aware copy instead of "from the Hall". */
    var pending = window.__hohPendingPartyRun;
    var fromOwnParty = !!(pending && pending.exact && pending.memberIds && pending.memberIds.length);
    /* Mobile detection — narrow viewports get ONE stable string for
       the full loading window. The rotating stages were glitching
       under main-thread pressure on phones (text overlapping,
       half-faded, not catching up to the interval). A single line
       reads cleanly and tells the user the same thing. */
    var isMobile = false;
    try { isMobile = window.matchMedia('(max-width: 600px)').matches; } catch(_){}
    txt.textContent='Gathering the '+scenario.label+'...';
    sub.textContent= fromOwnParty
      ? 'Reading your '+size+' hero'+(size===1?'':'es')+'.'
      : 'Pulling '+size+' face'+(size===1?'':'s')+' from the Hall.';
    if(isMobile){
      /* No rotation on mobile — leave the kickoff text up. */
      return;
    }
    var STAGES = fromOwnParty ? LOADING_STAGES_PARTY : LOADING_STAGES_HALL;
    var idx=0;
    loadingStageTimer=setInterval(function(){
      idx=(idx+1)%STAGES.length;
      var stage=STAGES[idx];
      txt.classList.add('hoh-fade-out');
      sub.classList.add('hoh-fade-out');
      setTimeout(function(){
        txt.textContent=stage.text;
        sub.textContent=stage.sub;
        void txt.offsetWidth;
        txt.classList.remove('hoh-fade-out');
        sub.classList.remove('hoh-fade-out');
      },320);
    },2400);
  }

  function stopLoadingMessages(){
    if(loadingStageTimer){clearInterval(loadingStageTimer);loadingStageTimer=null;}
  }

  function setHeader(eyebrow,title,subtitle){
    var eb=$('hoh-company-eyebrow');
    var tt=$('hoh-company-title');
    var st=$('hoh-company-subtitle');
    if(eb)eb.textContent=eyebrow;
    if(tt)tt.textContent=title;
    if(st)st.textContent=subtitle;
  }

  /* ============ PICKER ============ */
  /* R145-E: Trimmed the picker from 4 preset scenario tiles + Custom
     to just TWO choices: Random and Custom. The 4 presets are still
     defined in SCENARIOS — Random picks one of them at random and
     runs the build. Reduces decision fatigue at the entry point
     ("surprise me" vs "I have a specific scene") and clears space
     for the rolling-dice flourish that plays before the random pick
     commits. */
  function renderPicker(){
    var host=$('hoh-company-scenarios');
    if(!host)return;
    var hasFf = userOwnsFfPortrait();
    var diceIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8" cy="8" r="1.2" fill="currentColor"/><circle cx="16" cy="8" r="1.2" fill="currentColor"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/><circle cx="8" cy="16" r="1.2" fill="currentColor"/><circle cx="16" cy="16" r="1.2" fill="currentColor"/></svg>';
    var customIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 6.5L21 10l-5 4.5L17.5 22 12 18.4 6.5 22 8 14.5 3 10l6.6-1.5z"/></svg>';
    var lockIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 1 1 8 0v3"/></svg>';
    /* Random tile — always available. The label shows the 4 preset
       names spelled out underneath as a hint about what kinds of
       scenarios are in the pool, so the user knows what they're
       rolling for. */
    var randomTile = '<button type="button" class="hoh-company-scenario hoh-company-scenario-random" onclick="hohCompanyPickRandom()">' +
        '<div class="hoh-company-scenario-icon">' + diceIcon + '</div>' +
        '<div class="hoh-company-scenario-body">' +
          '<div class="hoh-company-scenario-name">Random</div>' +
          '<div class="hoh-company-scenario-blurb">Roll a scenario. The Hall picks one of the four archetypes and builds a company around it.</div>' +
          '<div class="hoh-company-scenario-pool">' +
            SCENARIOS.map(function(s){ return '<span class="hoh-company-scenario-pool-tag">' + esc(s.label) + '</span>'; }).join('') +
          '</div>' +
        '</div>' +
      '</button>';
    /* Custom tile — gated by FF Portrait ownership. */
    var customTile = hasFf
      ? '<button type="button" class="hoh-company-scenario hoh-company-scenario-custom hoh-company-scenario-custom-unlocked" onclick="hohCompanyPickScenario(\'custom\')">' +
          '<div class="hoh-company-scenario-icon hoh-company-scenario-icon-custom">' + customIcon + '</div>' +
          '<div class="hoh-company-scenario-body">' +
            '<div class="hoh-company-scenario-name">Custom <span class="hoh-company-pro-pill">Unlocked</span></div>' +
            '<div class="hoh-company-scenario-blurb">Write your party\'s situation in your own words. The Hall builds the dynamic around their backstories.</div>' +
          '</div>' +
        '</button>'
      : '<button type="button" class="hoh-company-scenario hoh-company-scenario-custom hoh-company-scenario-locked" onclick="hohCompanyShowCustomLock()" aria-label="Custom — unlocked when you commission an FF Portrait">' +
          '<div class="hoh-company-scenario-icon hoh-company-scenario-icon-custom">' + lockIcon + '</div>' +
          '<div class="hoh-company-scenario-body">' +
            '<div class="hoh-company-scenario-name">Custom <span class="hoh-company-locked-pill">FF Portrait perk</span></div>' +
            '<div class="hoh-company-scenario-blurb">Write the situation in your own words. Commission an FF Portrait to unlock the custom builder.</div>' +
          '</div>' +
        '</button>';
    host.innerHTML = randomTile + customTile;
    renderUsesLeft();
  }
  /* R145-E: Random scenario picker with a rolling animation. The user
     sees the 4 preset names cycle through the Random tile's name slot
     for ~1.2s, then it lands on the picked scenario name + auto-fires
     hohCompanyPickScenario(picked.id). Builds anticipation + makes the
     dice-roll feel real (matches the rest of the Hall's dice-y vibe). */
  window.hohCompanyPickRandom = function(){
    var btn = document.querySelector('.hoh-company-scenario-random');
    if(!btn) return;
    /* Prevent double-clicks while the animation is running. */
    if(btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('hoh-company-scenario-random-rolling');
    var nameEl = btn.querySelector('.hoh-company-scenario-name');
    var blurbEl = btn.querySelector('.hoh-company-scenario-blurb');
    var poolEl = btn.querySelector('.hoh-company-scenario-pool');
    /* Pick the winner upfront so the animation has a target. */
    var pickedIdx = Math.floor(Math.random() * SCENARIOS.length);
    var picked = SCENARIOS[pickedIdx];
    /* Hide the pool tags during the roll — they'd be redundant. */
    if(poolEl) poolEl.style.opacity = '0.25';
    /* Build a cycle order that ENDS on the picked scenario so the
       landing feels intentional. Start by shuffling the others, then
       append the winner at the end. */
    var cycleOrder = [];
    var ROLL_FRAMES = 8;
    for(var i = 0; i < ROLL_FRAMES; i++){
      cycleOrder.push(SCENARIOS[Math.floor(Math.random() * SCENARIOS.length)]);
    }
    cycleOrder[cycleOrder.length - 1] = picked;
    var frame = 0;
    function step(){
      if(frame >= cycleOrder.length){
        /* Land + commit. Brief pause so user reads the final name. */
        setTimeout(function(){
          try { btn.classList.remove('hoh-company-scenario-random-rolling'); } catch(_){}
          try { btn.classList.add('hoh-company-scenario-random-landed'); } catch(_){}
          if(typeof window.hohCompanyPickScenario === 'function'){
            try { window.hohCompanyPickScenario(picked.id); } catch(_){}
          }
        }, 480);
        return;
      }
      var s = cycleOrder[frame];
      if(nameEl) nameEl.textContent = s.label;
      if(blurbEl) blurbEl.textContent = s.blurb;
      frame++;
      /* Slow down progressively — first frames fast, last frames slow,
         so the landing feels like a dice settling. */
      var delay = 80 + Math.floor(frame * frame * 6);
      setTimeout(step, delay);
    }
    step();
  };
  /* R63: Locked-state explainer for non-FF users who tap For Your
     Own. Beautiful inline card (not a toast) so the value prop is
     legible and the path-to-unlock is one tap away. */
  window.hohCompanyShowCustomLock = function(){
    var modal = $('hoh-company-modal');
    if(!modal) return;
    var existing = document.getElementById('hoh-company-custom-lock');
    if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var card = document.createElement('div');
    card.id = 'hoh-company-custom-lock';
    card.className = 'hoh-company-custom-lock';
    card.innerHTML =
      '<div class="hoh-company-custom-lock-backdrop" data-cl-close="1"></div>' +
      '<div class="hoh-company-custom-lock-card" role="dialog" aria-modal="true" aria-labelledby="hoh-company-custom-lock-title">' +
        '<button type="button" class="hoh-company-custom-lock-close" data-cl-close="1" aria-label="Close">&times;</button>' +
        '<div class="hoh-company-custom-lock-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 6.5L21 10l-5 4.5L17.5 22 12 18.4 6.5 22 8 14.5 3 10l6.6-1.5z"/></svg>' +
        '</div>' +
        '<div class="hoh-company-custom-lock-eyebrow">For Your Own</div>' +
        '<h3 class="hoh-company-custom-lock-title" id="hoh-company-custom-lock-title">A custom mode for those who\'ve commissioned a portrait.</h3>' +
        '<p class="hoh-company-custom-lock-body">' +
          'Write the situation in your own words. The Hall reads every hero\'s backstory and weaves something only THIS party could star in. ' +
          'It\'s the centerpiece of the Company tool, and we\'ve kept it for the people who\'ve gone the distance to commission a real portrait.' +
        '</p>' +
        '<div class="hoh-company-custom-lock-perks">' +
          '<div class="hoh-company-custom-lock-perk">' +
            '<span class="hoh-company-custom-lock-check" aria-hidden="true">&#10003;</span>' +
            '<span>Custom situation. Whatever you want them stuck in.</span>' +
          '</div>' +
          '<div class="hoh-company-custom-lock-perk">' +
            '<span class="hoh-company-custom-lock-check" aria-hidden="true">&#10003;</span>' +
            '<span>Pre-written character relationships, factored into the dynamic.</span>' +
          '</div>' +
          '<div class="hoh-company-custom-lock-perk">' +
            '<span class="hoh-company-custom-lock-check" aria-hidden="true">&#10003;</span>' +
            '<span>Per-hero role tweaks. Refine what each one brings.</span>' +
          '</div>' +
          '<div class="hoh-company-custom-lock-perk">' +
            '<span class="hoh-company-custom-lock-check" aria-hidden="true">&#10003;</span>' +
            '<span>Five daily companies instead of three.</span>' +
          '</div>' +
        '</div>' +
        '<div class="hoh-company-custom-lock-actions">' +
          '<a class="hoh-company-custom-lock-cta" href="https://framedfantasy.com/products/fantasy-character-commission" target="_blank" rel="noopener">' +
            'See the FF Portrait commissions' +
          '</a>' +
          '<button type="button" class="hoh-company-custom-lock-cancel" data-cl-close="1">Maybe later</button>' +
        '</div>' +
      '</div>';
    modal.appendChild(card);
    function close(){
      try { if(card.parentNode) card.parentNode.removeChild(card); } catch(_){}
      /* R318: the Escape handler removed itself, but a click-close leaked one
         document keydown listener per open. Remove it on every close path. */
      try { document.removeEventListener('keydown', onKey); } catch(_){}
    }
    card.addEventListener('click', function(e){
      if(e.target && e.target.closest && e.target.closest('[data-cl-close]')){
        close();
      }
    });
    /* Esc closes too. */
    function onKey(e){
      if(e.key === 'Escape'){
        document.removeEventListener('keydown', onKey);
        close();
      }
    }
    document.addEventListener('keydown', onKey);
  };

  function renderUsesLeft(){
    var wrap=$('hoh-company-uses');
    var leftEl=$('hoh-company-uses-left');
    var capEl=$('hoh-company-uses-cap');
    if(!wrap||!leftEl||!capEl)return;
    var left=Math.max(0,usesLeft()|0);
    var cap=capTotal();
    leftEl.textContent=String(left);
    capEl.textContent=String(cap);
    wrap.classList.toggle('hoh-company-uses-low',left<=1);
    /* Use flex (matching the CSS rule). inline-flex would break the
       margin:0 auto centering inside the block-level .hoh-company-view
       parent, leaving the chip left-aligned on both mobile + desktop. */
    wrap.style.display='flex';
  }

  /* ============ CUSTOM BUILDER (R63 redesign) ============
     For Your Own is now a per-PARTY custom. The user must arrive
     here with a party already pinned via __hohPendingPartyRun.exact
     (the source picker forces this). The builder shows the party\'s
     heroes read-only with optional role refinement, plus three text
     fields:
       - Company name (optional)
       - Situation (REQUIRED — the heart of the prompt)
       - Relationships (optional, free-form bullets describing how
         these characters relate to each other)
     We also surface any roles the user already saved on each hero
     in My Party (Cast tags) as the default role text — so the
     builder feels like an extension of work they\'ve already done. */
  var CUSTOM_PROMPT_MAX = 320; /* R63: bumped 220→320 — more room for situation depth. */
  var CUSTOM_PROMPT_MIN_DISPLAY = 30; /* R111-C: floor for Forge to fire. Shown live in the counter so users see the minimum before submitting. */
  var CUSTOM_NAME_MAX = 60;
  var CUSTOM_ROLE_MAX = 80;
  var CUSTOM_RELATIONSHIP_MAX = 220;

  /* Read the cast-tag roles the user saved in My Favorites for a
     given hero. Returns a comma-joined human-readable string like
     "Ally, Boss" or '' if none. The Cast tab stores roles as an
     array of role keys ('ally','rival','boss',...); we map them to
     friendly labels here. */
  function castRolesForHero(heroId){
    try {
      if(typeof window.hohHallGetRoles === 'function'){
        var rolesArr = window.hohHallGetRoles(heroId) || [];
        if(!rolesArr.length) return '';
        var labels = {
          ally: 'Ally', rival: 'Rival', boss: 'Boss', patron: 'Patron',
          quest_giver: 'Quest giver', background: 'Background'
        };
        return rolesArr.map(function(r){ return labels[r] || r; }).join(', ');
      }
    } catch(_){}
    return '';
  }

  /* R77: Draft persistence helpers. We save the user\'s in-progress
     edits (custom name, situation, relationships, per-hero roles,
     plus any X-removed / Add-Member modifications to the member
     list) so they don\'t lose work if they accidentally close the
     Company tool. Drafts are scoped per partyId — if the user picks
     a different party, that party gets its own draft slot, no
     cross-contamination. The Reset link clears the current party\'s
     draft and reverts to the original party composition. */
  var DRAFT_KEY_PREFIX = 'hoh-company-draft-v1-';
  function draftKey(partyId){ return DRAFT_KEY_PREFIX + String(partyId || 'noparty'); }
  function draftLoad(partyId){
    if(!partyId) return null;
    try {
      var raw = localStorage.getItem(draftKey(partyId));
      if(!raw) return null;
      var d = JSON.parse(raw);
      return (d && typeof d === 'object') ? d : null;
    } catch(_){ return null; }
  }
  function draftSave(partyId, data){
    if(!partyId) return;
    try { localStorage.setItem(draftKey(partyId), JSON.stringify(data || {})); } catch(_){}
  }
  function draftClear(partyId){
    if(!partyId) return;
    try { localStorage.removeItem(draftKey(partyId)); } catch(_){}
  }
  /* Read current form values from the DOM and persist to the draft
     for the current pending party. Called on every input change. */
  function persistCurrentDraft(){
    var pending = window.__hohPendingPartyRun;
    if(!pending || !pending.partyId) return;
    var nameEl = $('hoh-company-custom-name');
    var promptEl = $('hoh-company-custom-prompt');
    var relEl = $('hoh-company-custom-rel');
    draftSave(pending.partyId, {
      memberIds: (pending.memberIds || []).slice(),
      customName: nameEl ? String(nameEl.value || '').slice(0, CUSTOM_NAME_MAX) : '',
      customPrompt: promptEl ? String(promptEl.value || '').slice(0, CUSTOM_PROMPT_MAX) : '',
      relationships: relEl ? String(relEl.value || '').slice(0, CUSTOM_RELATIONSHIP_MAX) : '',
      roleMap: Object.assign({}, window.__hohCustomRoles || {}),
      savedAt: Date.now()
    });
  }
  window.hohCompanyPersistDraft = persistCurrentDraft;

  function renderCustomBuilder(){
    var host = $('hoh-company-custom-body');
    if(!host) return;
    /* The pinned party is required. Source picker enforces this; if
       somehow we got here without one, send the user back. */
    var pending = window.__hohPendingPartyRun;
    if(!pending || !pending.exact || !Array.isArray(pending.memberIds) || !pending.memberIds.length){
      host.innerHTML = '<div class="hoh-company-custom-empty">' +
        '<strong>Pick a party first.</strong><br>' +
        'For Your Own builds the company around a party you\'ve already saved. Head to My Party, build one, then come back.' +
        '<div style="margin-top:14px;"><button type="button" class="hoh-company-custom-cancel" onclick="hohCompanyResetToPicker()">Back</button></div>' +
        '</div>';
      return;
    }
    /* R77: Restore draft for this party if one exists AND we haven\'t
       already restored it for THIS party (tracked per-party so
       switching parties picks up the new party\'s draft). The flag
       avoids overwriting fresh edits with an older draft when the
       user removes/adds a member (which triggers a re-render). */
    var draft = (window.__hohDraftHydratedFor !== pending.partyId) ? draftLoad(pending.partyId) : null;
    if(draft){
      /* Restore member list — user may have X-removed someone and
         their draft preserves that decision. */
      if(Array.isArray(draft.memberIds) && draft.memberIds.length){
        pending.memberIds = draft.memberIds.slice();
      }
      window.__hohCustomRoles = Object.assign({}, draft.roleMap || {});
      window.__hohCustomRelationships = draft.relationships || '';
      window.__hohDraftHydratedFor = pending.partyId;
    } else if(window.__hohDraftHydratedFor !== pending.partyId){
      /* New party with no draft — reset state so we don\'t carry
         over the previous party\'s edits. */
      window.__hohCustomRoles = {};
      window.__hohCustomRelationships = '';
      window.__hohDraftHydratedFor = pending.partyId;
    }
    /* Resolve the party heroes from the global character pool. */
    var pool = (typeof window.hohGetAllCharacters === 'function') ? (window.hohGetAllCharacters() || []) : [];
    var byId = {}; pool.forEach(function(c){ if(c && c.id) byId[c.id] = c; });
    var members = pending.memberIds.map(function(id){ return byId[id]; }).filter(Boolean);
    if(!members.length){
      host.innerHTML = '<div class="hoh-company-custom-empty">' +
        '<strong>The party heroes aren\'t loaded yet.</strong><br>' +
        'Hang on a moment and try again, or close and reopen the Company tool.' +
        '</div>';
      return;
    }
    /* Seed role/relationship maps. R77: only seed from cast tags for
       heroes that DON\'T already have a role in the current state
       (preserve user edits across re-renders triggered by X-remove
       or Add-Member). */
    window.__hohCustomRoles = window.__hohCustomRoles || {};
    members.forEach(function(c){
      if(window.__hohCustomRoles[c.id] == null || window.__hohCustomRoles[c.id] === ''){
        var seed = castRolesForHero(c.id);
        if(seed) window.__hohCustomRoles[c.id] = seed;
      }
    });
    if(window.__hohCustomRelationships == null) window.__hohCustomRelationships = '';
    var partyName = pending.partyName || 'Your Party';
    /* Default company name = party name OR draft override. */
    var defaultCompanyName = (draft && draft.customName) ? draft.customName : partyName;
    var defaultPrompt = (draft && draft.customPrompt) ? draft.customPrompt : '';
    var defaultRel = (draft && draft.relationships) ? draft.relationships : '';
    /* Hero rows — portrait + name + meta + role input + X to remove.
       The X removes the hero from pending.memberIds and re-renders
       the form so the party shrinks live. R77: roles persist via
       __hohCustomRoles so re-renders don\'t blow away typed values. */
    var heroRowsHtml = members.map(function(c){
      var img = c.image_thumb_url || c.image_url || '';
      var firstLetter = esc((c.name || '?').charAt(0));
      var media = img
        ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" crossorigin="anonymous" data-letter="' + firstLetter + '" onerror="if(window.hohImgFallback)hohImgFallback(this);">'
        : '<div class="hoh-company-custom-letter">' + firstLetter + '</div>';
      var meta = (c.race || '') + (c.character_class ? ' · ' + c.character_class : '');
      var roleVal = (window.__hohCustomRoles && window.__hohCustomRoles[c.id]) || '';
      return '<div class="hoh-company-custom-hero hoh-company-custom-hero-locked" data-hero-id="' + esc(c.id) + '">' +
        '<div class="hoh-company-custom-hero-media">' + media + '</div>' +
        '<div class="hoh-company-custom-hero-info">' +
          '<div class="hoh-company-custom-hero-name">' + esc(c.name || 'Unnamed') + '</div>' +
          '<div class="hoh-company-custom-hero-meta">' + esc(meta) + '</div>' +
          '<input type="text" class="hoh-company-custom-hero-role" placeholder="Their role (optional)" maxlength="' + CUSTOM_ROLE_MAX + '" value="' + esc(roleVal) + '" data-role-for="' + esc(c.id) + '" oninput="hohCompanyCustomSetRole(\'' + esc(c.id) + '\', this.value)">' +
        '</div>' +
        /* R77: Remove button — guarded so we never let the user drop
           below 1 member (the form needs at least one hero to be
           meaningful). When members.length === 1 the X is hidden. */
        (members.length > 1
          ? '<button type="button" class="hoh-company-custom-hero-remove" aria-label="Remove ' + esc(c.name || 'hero') + ' from this party" onclick="hohCompanyRemoveHero(\'' + esc(c.id) + '\')">&times;</button>'
          : '') +
      '</div>';
    }).join('');
    /* R77: Add Member empty slot when party has < 5 heroes. The slot
       is a dashed-border placeholder that opens the hero picker. */
    var addMemberHtml = (members.length < 5)
      ? '<button type="button" class="hoh-company-custom-add-member" onclick="hohCompanyOpenAddMember()">' +
          '<span class="hoh-company-custom-add-member-icon" aria-hidden="true">+</span>' +
          '<span class="hoh-company-custom-add-member-label">Add Member</span>' +
        '</button>'
      : '';
    /* Reset link — only show when a draft exists. */
    var resetLinkHtml = draftLoad(pending.partyId)
      ? '<button type="button" class="hoh-company-custom-reset" onclick="hohCompanyResetDraft()" title="Clear your saved edits and start fresh">Reset draft</button>'
      : '';
    host.innerHTML =
      '<div class="hoh-company-custom-section">' +
        '<label class="hoh-company-custom-label">Company name <span class="hoh-company-custom-optional">optional</span></label>' +
        '<input type="text" id="hoh-company-custom-name" class="hoh-company-custom-input" placeholder="e.g. The Last Lantern" maxlength="' + CUSTOM_NAME_MAX + '" value="' + esc(defaultCompanyName) + '" oninput="hohCompanyPersistDraft()">' +
      '</div>' +
      '<div class="hoh-company-custom-section">' +
        '<label class="hoh-company-custom-label">Your party <span class="hoh-company-custom-optional">' + members.length + ' hero' + (members.length === 1 ? '' : 'es') + '</span></label>' +
        '<div class="hoh-company-custom-hero-help">Refine each hero\'s role for this scenario. Tap the &times; to remove a hero, or Add Member to bring in another.</div>' +
        '<div class="hoh-company-custom-heroes hoh-company-custom-heroes-locked">' + heroRowsHtml + addMemberHtml + '</div>' +
      '</div>' +
      '<div class="hoh-company-custom-section">' +
        '<label class="hoh-company-custom-label">The situation <span class="hoh-company-custom-counter' + (defaultPrompt.length < CUSTOM_PROMPT_MIN_DISPLAY ? ' hoh-company-custom-counter-under' : '') + '" id="hoh-company-custom-counter">' + (defaultPrompt.length) + '/' + CUSTOM_PROMPT_MAX + (defaultPrompt.length < CUSTOM_PROMPT_MIN_DISPLAY ? ' (min ' + CUSTOM_PROMPT_MIN_DISPLAY + ')' : '') + '</span></label>' +
        '<div class="hoh-company-custom-hero-help">What\'s happening to this party right now? The Hall reads everyone\'s backstory and weaves the dynamic around your prompt.</div>' +
        '<textarea id="hoh-company-custom-prompt" class="hoh-company-custom-textarea" placeholder="They\'ve been hired to recover a stolen relic from a rival noble house. The job is at a masquerade tonight, and one of them used to court the host." maxlength="' + CUSTOM_PROMPT_MAX + '" oninput="hohCompanyCustomCountChars();hohCompanyPersistDraft();">' + esc(defaultPrompt) + '</textarea>' +
      '</div>' +
      '<div class="hoh-company-custom-section">' +
        '<label class="hoh-company-custom-label">Relationships <span class="hoh-company-custom-optional">optional</span></label>' +
        '<div class="hoh-company-custom-hero-help">Anything we should know about how they get along? E.g. "X owes Y money" or "Z secretly admires W".</div>' +
        '<textarea id="hoh-company-custom-rel" class="hoh-company-custom-textarea hoh-company-custom-textarea-rel" placeholder="One line per relationship is fine." maxlength="' + CUSTOM_RELATIONSHIP_MAX + '" oninput="hohCompanyCustomSetRel(this.value);hohCompanyPersistDraft();">' + esc(defaultRel) + '</textarea>' +
      '</div>' +
      /* R77: Three actions stacked. Visual order via CSS:
         1. Forge the Company (primary CTA, larger)
         2. Pick Another Party (secondary)
         3. Back (tertiary)
         Reset link sits below as a quiet escape hatch when a draft
         exists. */
      '<div class="hoh-company-custom-actions">' +
        '<button type="button" class="hoh-company-custom-pickparty" onclick="hohCompanyOpenPartyTab()">Pick Another Party</button>' +
        '<button type="button" class="hoh-company-custom-cancel" onclick="hohCompanyResetToPicker()">Back</button>' +
        '<button type="button" class="hoh-company-custom-go" onclick="hohCompanyRunCustom()">Forge the Company</button>' +
      '</div>' +
      (resetLinkHtml ? '<div class="hoh-company-custom-reset-wrap">' + resetLinkHtml + '</div>' : '');
  }
  /* R77: X-button handler. Removes the hero from pending.memberIds,
     prunes their saved role from the role map, persists the draft,
     and re-renders. Guards against dropping below 1 member. */
  window.hohCompanyRemoveHero = function(heroId){
    var pending = window.__hohPendingPartyRun;
    if(!pending || !Array.isArray(pending.memberIds)) return;
    if(pending.memberIds.length <= 1) return;
    pending.memberIds = pending.memberIds.filter(function(id){ return id !== heroId; });
    if(window.__hohCustomRoles) delete window.__hohCustomRoles[heroId];
    persistCurrentDraft();
    renderCustomBuilder();
  };
  /* R77: Add Member handler. Opens the hero picker in callback mode
     (via hohHallOpenHeroPicker exposed from hoh-hall-party.js). The
     callback receives the picked hero ID and adds it to the member
     list, capped at 5. */
  window.hohCompanyOpenAddMember = function(){
    var pending = window.__hohPendingPartyRun;
    if(!pending || !Array.isArray(pending.memberIds)) return;
    if(pending.memberIds.length >= 5){
      if(typeof window.hohShowHallToast === 'function'){
        try { window.hohShowHallToast('A company maxes at 5 heroes.'); } catch(_){}
      }
      return;
    }
    if(typeof window.hohHallOpenHeroPicker !== 'function') return;
    window.hohHallOpenHeroPicker({
      excludeIds: pending.memberIds.slice(),
      onPick: function(heroId){
        if(!heroId) return;
        if(pending.memberIds.indexOf(heroId) !== -1) return; /* dupe guard */
        if(pending.memberIds.length >= 5) return;
        pending.memberIds.push(heroId);
        persistCurrentDraft();
        renderCustomBuilder();
      }
    });
  };
  /* R77: Reset draft — clears localStorage entry for this party and
     reloads the form from scratch (original member list, no saved
     prompts). */
  window.hohCompanyResetDraft = function(){
    var pending = window.__hohPendingPartyRun;
    if(!pending) return;
    if(!confirm('Clear your saved Company edits for this party?')) return;
    draftClear(pending.partyId);
    /* Restore the original party member list from saved party data. */
    try {
      var hall = (typeof window.hohHallGet === 'function') ? window.hohHallGet() : null;
      if(hall && Array.isArray(hall.parties)){
        var party = hall.parties.find(function(p){ return p.id === pending.partyId; });
        if(party && Array.isArray(party.slots)){
          pending.memberIds = party.slots.filter(Boolean).slice();
        }
      }
    } catch(_){}
    window.__hohCustomRoles = {};
    window.__hohCustomRelationships = '';
    window.__hohDraftHydrated = false;
    renderCustomBuilder();
  };
  /* R75: Open Your Hall on the My Party tab. Lets the user swap which
     party runs this scenario without manually navigating back through
     two screens. Falls through if Your Hall isn\'t loaded. */
  window.hohCompanyOpenPartyTab = function(){
    try {
      if(typeof window.hohOpenYourHall === 'function') window.hohOpenYourHall();
      setTimeout(function(){
        if(typeof window.hohYourHallSwitchView === 'function'){
          try { window.hohYourHallSwitchView('party'); } catch(_){}
        }
      }, 30);
    } catch(_){}
  };
  /* R63: hero pick toggle removed — heroes come from the chosen
     party, not a checkbox grid. Stub kept for any legacy callers
     so we don\'t blow up if some old onclick lingers in cached HTML. */
  window.hohCompanyCustomToggle = function(){};
  window.hohCompanyCustomSetRole = function(heroId, value){
    window.__hohCustomRoles = window.__hohCustomRoles || {};
    window.__hohCustomRoles[heroId] = String(value || '').slice(0, CUSTOM_ROLE_MAX);
    /* R77: Persist on every keystroke so accidental closures don\'t
       lose the role-refinement work. */
    persistCurrentDraft();
  };
  window.hohCompanyCustomSetRel = function(value){
    window.__hohCustomRelationships = String(value || '').slice(0, CUSTOM_RELATIONSHIP_MAX);
  };
  window.hohCompanyCustomCountChars = function(){
    var ta = $('hoh-company-custom-prompt');
    var counter = $('hoh-company-custom-counter');
    if(!ta || !counter) return;
    var len = (ta.value || '').length;
    /* R111-C: surface the minimum-30 requirement live in the counter
       so users see it before they hit Forge. Once over the floor we
       drop the "min 30" bit and just show the standard X/MAX. */
    if(len < CUSTOM_PROMPT_MIN_DISPLAY){
      counter.textContent = len + '/' + CUSTOM_PROMPT_MAX + ' (min ' + CUSTOM_PROMPT_MIN_DISPLAY + ')';
      counter.classList.add('hoh-company-custom-counter-under');
    } else {
      counter.textContent = len + '/' + CUSTOM_PROMPT_MAX;
      counter.classList.remove('hoh-company-custom-counter-under');
    }
  };
  window.hohCompanyResetToPicker = function(){
    setHeader('THE DM\'S SATCHEL', 'Gather a Company', 'Pick a scenario. Your party fills the seats.');
    showView('picker');
  };
  /* R63: Custom run handler — collects the inputs and routes through
     the same worker call as a preset scenario. Heroes are now
     determined by the pinned party (not picked here), so we just
     read pending.memberIds and assemble the payload. Situation is
     required; everything else is optional. */
  window.hohCompanyRunCustom = function(){
    var pending = window.__hohPendingPartyRun;
    if(!pending || !pending.exact || !Array.isArray(pending.memberIds) || !pending.memberIds.length){
      if(typeof window.hohShowHallToast === 'function'){
        try { window.hohShowHallToast('Pick a party first.'); } catch(_){}
      }
      return;
    }
    var ids = pending.memberIds.slice();
    var nameEl = $('hoh-company-custom-name');
    var promptEl = $('hoh-company-custom-prompt');
    var customName = nameEl ? String(nameEl.value || '').trim().slice(0, CUSTOM_NAME_MAX) : '';
    var customPrompt = promptEl ? String(promptEl.value || '').trim().slice(0, CUSTOM_PROMPT_MAX) : '';
    /* R111-C: minimum chars for the situation. A bare prompt of
       "they fight" gives the Hall nothing to weave from — set a real
       floor so the worker has actual context to work with. Mirrors
       CUSTOM_PROMPT_MIN_DISPLAY (the live-counter threshold) so the
       counter and the validator agree. */
    var CUSTOM_PROMPT_MIN = CUSTOM_PROMPT_MIN_DISPLAY;
    if(!customPrompt){
      if(typeof window.hohShowHallToast === 'function'){
        try { window.hohShowHallToast('Write a one-line situation so the Hall knows what they\'re in.'); } catch(_){}
      }
      var t = $('hoh-company-custom-prompt');
      if(t){ try { t.focus(); } catch(_){} }
      return;
    }
    if(customPrompt.length < CUSTOM_PROMPT_MIN){
      var remaining = CUSTOM_PROMPT_MIN - customPrompt.length;
      if(typeof window.hohShowHallToast === 'function'){
        try { window.hohShowHallToast('Give the Hall a bit more — ' + remaining + ' more character' + (remaining === 1 ? '' : 's') + ' so the dynamic has something to weave from.'); } catch(_){}
      }
      var t2 = $('hoh-company-custom-prompt');
      if(t2){ try { t2.focus(); } catch(_){} }
      return;
    }
    /* Build the role_assignments payload for the worker. Empty strings
       are kept so the worker knows which heroes were intentionally
       left "no preference". */
    var roleMap = {};
    for(var i = 0; i < ids.length; i++){
      var rid = ids[i];
      var rv = (window.__hohCustomRoles && window.__hohCustomRoles[rid]) || '';
      roleMap[rid] = String(rv).slice(0, CUSTOM_ROLE_MAX);
    }
    var relationships = String(window.__hohCustomRelationships || '').slice(0, CUSTOM_RELATIONSHIP_MAX);
    window.__hohCustomPayload = {
      custom_prompt: customPrompt,
      custom_name: customName,
      role_assignments: roleMap,
      relationships: relationships
    };
    /* Fire the standard fetch path. Size = party.length, capped at 5. */
    if(typeof window.hohCompanyPickSize === 'function'){
      window.hohCompanyPickSize(Math.min(5, ids.length));
    }
  };

  /* R63: Size picker removed. This stub stays only so old cached
     HTML with onclick="hohCompanyPickSize(...)" or a ref to the
     element does not throw on load. The new flow is: scenario click
     → check pending party → fire fetch directly. */
  function renderSizePicker(){ /* no-op (R63) */ }

  /* ============ RATE LIMIT ============ */
  /* R43: usesLeft must respect the dynamic cap (5 for FF_Portrait
     owners, 3 otherwise). The host\'s window.hohCompanyUsesLeft uses
     the static HOH_COMPANY_DAILY_CAP, so we recompute against
     capTotal() locally. We still read the host\'s usage counter
     (window.hohGetCompanyUsage) so the count source stays
     authoritative — only the cap math is overridden. */
  function usesLeft(){
    if(typeof window.hohGetCompanyUsage === 'function'){
      try {
        var u = window.hohGetCompanyUsage() || { count: 0 };
        return Math.max(0, capTotal() - (u.count || 0));
      } catch(_){}
    }
    if(typeof window.hohCompanyUsesLeft==='function')return window.hohCompanyUsesLeft();
    return 99;
  }
  /* R43: FF_Portrait owners get an upgraded daily cap (5 vs 3). The
     check looks at the user\'s submitted heroes for any with the
     is_ff_portrait flag — that flag is what marks a paid commission
     in the data layer. Falls back to the host-defined cap if the
     check can\'t run for any reason. */
  function userOwnsFfPortrait(){
    try {
      if(typeof window.hohYourHallSubmittedRows === 'function'){
        var rows = window.hohYourHallSubmittedRows() || [];
        for(var i=0;i<rows.length;i++){
          if(rows[i] && rows[i].is_ff_portrait) return true;
        }
      }
    } catch(_){}
    return false;
  }
  function capTotal(){
    var hostCap = typeof window.hohCompanyDailyCap==='number'?window.hohCompanyDailyCap:3;
    if(userOwnsFfPortrait()) return Math.max(hostCap, 5);
    return hostCap;
  }
  function bumpUsage(){
    if(typeof window.hohIncrementCompanyUsage==='function')window.hohIncrementCompanyUsage();
  }

  /* ============ FLOW ============ */
  window.hohOpenCompanyTool=function(){
    var modal=$('hoh-company-modal');
    if(!modal)return;
    currentScenario=null;
    currentCompany=null;
    currentCharacters=null;
    /* R265: Gather a Company is PAUSED while new party features are built.
       Every entry point funnels through here, so intercepting at the top
       disables the whole (currently broken) generation flow and shows a
       friendly "coming soon" panel instead. To re-enable later, delete this
       block. */
    if(!window.__hohCompanyToolEnabled){
      setHeader('The DM\'s Satchel', 'Coming Soon', 'New party features are on the way.');
      showView('soon');
      modal.style.display='flex';
      document.body.style.overflow='hidden';
      return;
    }
    /* Header copy is context-aware. When the user fired Run This
       Party (or re-ran a saved company) the pending state is set
       BEFORE this open. We detect that and use party-specific
       copy so the modal doesn't lie about pulling faces from the
       Hall — the faces are coming from the user's own party. */
    var pending = window.__hohPendingPartyRun;
    var fromOwnParty = !!(pending && pending.exact && pending.memberIds && pending.memberIds.length);
    if(fromOwnParty){
      setHeader(
        'Run Your Party',
        'Pick a Scenario',
        'Your saved party becomes the company. Pick a scenario and the dynamic generates instantly.'
      );
    } else {
      setHeader('The DM\'s Satchel','Gather a Company','Pick a scenario. The Hall provides the faces.');
    }

    if(usesLeft()<=0){
      var capEl=$('hoh-company-locked-cap');
      if(capEl)capEl.textContent=String(capTotal());
      setHeader('The DM\'s Satchel','Daily Limit Reached','Come back tomorrow for more companies.');
      showView('locked');
    }else{
      renderPicker();
      showView('picker');
    }
    modal.style.display='flex';
    document.body.style.overflow='hidden';
    /* Restore the "only my liked heroes" toggle state. The button is
       a child of the picker view so it is present once we render the
       picker.

       Two cases hide the toggle:
       1. The user is inside Your Hall (hoh-page-mode-yours body
          class). Their flow is "pick a party → pick a scenario →
          run" and a separate "liked" filter just clutters that.
       2. A pending exact-member run is queued. The members are
          already determined, so a pool filter is meaningless.

       The v2 "Only my Cast" toggle was intentionally removed from
       this tool entirely. Cast filtering happens automatically via
       the __hohPendingPartyRun state when the user fires the tool
       from Run This Cast / Run This Party / Saved Company Run
       Again. */
    var likedBtn = document.getElementById('hoh-company-liked-toggle');
    var inYourHall = document.body && document.body.classList.contains('hoh-page-mode-yours');
    var hasPending = !!(window.__hohPendingPartyRun && window.__hohPendingPartyRun.memberIds && window.__hohPendingPartyRun.memberIds.length);
    if(likedBtn){
      if(inYourHall || hasPending){
        likedBtn.style.display = 'none';
      } else {
        likedBtn.style.display = '';
      }
    }
    if (!inYourHall && !hasPending && typeof window.hohRestoreLikedOnlyToggle === 'function'){
      window.hohRestoreLikedOnlyToggle('company');
    }
  };

  window.hohCloseCompanyTool=function(){
    var modal=$('hoh-company-modal');
    if(!modal)return;
    modal.style.display='none';
    stopLoadingMessages();
    /* Don't unlock body scroll if another modal is still open on top. */
    var detail=document.getElementById('hoh-modal');
    var detailOpen=detail&&detail.style.display==='flex';
    if(!detailOpen)document.body.style.overflow='';
  };

  window.hohCompanyReset=function(){
    currentScenario=null;
    currentCompany=null;
    currentCharacters=null;
    setHeader('The DM\'s Satchel','Gather a Company','Pick a scenario. The Hall provides the faces.');
    if(usesLeft()<=0){
      var capEl=$('hoh-company-locked-cap');
      if(capEl)capEl.textContent=String(capTotal());
      setHeader('The DM\'s Satchel','Daily Limit Reached','Come back tomorrow for more companies.');
      showView('locked');
      return;
    }
    renderPicker();
    showView('picker');
  };

  window.hohCompanyBackToScenarios=function(){
    currentScenario=null;
    setHeader('The DM\'s Satchel','Gather a Company','Pick a scenario. The Hall provides the faces.');
    showView('picker');
  };

  window.hohCompanyPickScenario=function(scenarioId){
    /* R63: 'custom' is For Your Own — locked behind FF Portrait. */
    if(scenarioId === 'custom'){
      if(!userOwnsFfPortrait()){
        if(typeof window.hohCompanyShowCustomLock === 'function') window.hohCompanyShowCustomLock();
        return;
      }
      currentScenario = {
        id: 'custom',
        label: 'For Your Own',
        vibe: 'A custom company shaped by the user. Read every hero\'s backstory, the user\'s situation prompt, and any relationships they\'ve outlined. The output should feel like it was written specifically for THIS party — not a generic preset.'
      };
      setHeader('FOR YOUR OWN','Build Your Company','Refine roles and write the situation. The Hall does the rest.');
      renderCustomBuilder();
      showView('custom');
      return;
    }
    var scenario=SCENARIOS.find(function(s){return s.id===scenarioId;});
    if(!scenario){showError('Unknown scenario.');return;}
    currentScenario=scenario;
    /* R63: ALL preset scenarios now require a pinned party (the source
       picker enforces this). Size = party.length (capped at 5). No
       more "pull random faces from the Hall" path — Company is
       always YOUR party. */
    var pending = window.__hohPendingPartyRun;
    if(pending && pending.exact && Array.isArray(pending.memberIds) && pending.memberIds.length >= 2){
      var pendingSize = Math.min(5, pending.memberIds.length);
      window.hohCompanyPickSize(pendingSize);
      return;
    }
    /* No pinned party — show a "pick a party first" empty state in the
       picker view itself. This is a defensive fallback; the source
       picker should never let users get here without one. */
    showError('Pick a party from My Party first, then come back to choose a scenario.');
  };

  function showError(msg){
    var el=$('hoh-company-error-text');
    if(el)el.textContent=msg||'Something went wrong gathering the company.';
    showView('error');
  }

  window.hohCompanyPickSize=async function(n){
    var scenario=currentScenario;
    if(!scenario){showError('Pick a scenario first.');return;}
    var size=parseInt(n,10);
    /* Server-enforced range is 2..5. Anything else is rejected so we
       gate here too — better an explicit error message than a generic
       400 from the worker. The Run-This-Party path that used to pass
       6 is now clamped to 5 at its call site. */
    if(isNaN(size)||size<2||size>5){showError('Pick a valid party size.');return;}

    /* Final rate-limit gate (pre-flight). */
    if(usesLeft()<=0){
      setHeader('The DM\'s Satchel','Daily Limit Reached','Come back tomorrow for more companies.');
      var capEl=$('hoh-company-locked-cap');
      if(capEl)capEl.textContent=String(capTotal());
      showView('locked');
      return;
    }

    /* R63: Custom path no longer detours through a size picker —
       For Your Own renders directly off the pinned party. The
       builder calls hohCompanyRunCustom which sets __hohCustomPayload
       and re-enters this function, at which point we proceed with
       the fetch. If somehow we got here on a custom run with no
       payload set yet, that\'s a programmer error — bail safely. */
    if(scenario && scenario.id === 'custom' && !window.__hohCustomPayload){
      renderCustomBuilder();
      showView('custom');
      return;
    }

    if(typeof window.hohClaimActionHeart==='function')window.hohClaimActionHeart('company',$('hoh-company-modal'),'For gathering a company.');

    var sb=supa();
    if(!sb){showError('Database unavailable. Refresh the page and try again.');return;}

    var pendingForHeader = window.__hohPendingPartyRun;
    var fromOwnPartyForHeader = !!(pendingForHeader && pendingForHeader.exact && pendingForHeader.memberIds && pendingForHeader.memberIds.length);
    setHeader(
      scenario.label.toUpperCase(),
      'Gathering the '+scenario.label,
      fromOwnPartyForHeader
        ? 'Reading your '+size+' hero'+(size===1?'':'es')+'.'
        : 'Pulling '+size+' face'+(size===1?'':'s')+' from the Hall.'
    );
    renderLoadingSlots(size);
    /* Reset progress bar by re-inserting the fill element. */
    var barHost=document.querySelector('.hoh-company-loading-bar');
    if(barHost)barHost.innerHTML='<div class="hoh-company-loading-bar-fill"></div>';
    showView('loading');
    startLoadingMessages(scenario,size);

    try{
      var pending = window.__hohPendingPartyRun;
      var chars;

      if(pending && pending.exact && Array.isArray(pending.memberIds) && pending.memberIds.length){
        /* Exact-member fetch path. Used by Run This Party and Saved
           Company Run Again. We fetch by ID directly so the pool is
           guaranteed to include the user's chosen members even if
           they're older than the top-80 query window. */
        var idList = pending.memberIds.map(String);
        var byIdRes = await sb
          .from('characters')
          .select('id,name,race,character_class,level,campaign,image_url,image_thumb_url,npc_card')
          .in('id', idList);
        if(byIdRes.error) throw byIdRes.error;
        chars = byIdRes.data || [];
        /* Preserve the user's slot order for consistent NPC card
           layout — the worker treats array index as positioning. */
        var orderMap = {}; idList.forEach(function(id,i){ orderMap[id] = i; });
        chars.sort(function(a,b){ return (orderMap[String(a.id)]||0) - (orderMap[String(b.id)]||0); });
        /* Consume the pending state so the next Company run isn't
           accidentally pinned to the same set. */
        window.__hohPendingPartyRun = null;
      } else {
        /* Standard path: top recent NPC-carded characters. */
        var pool=await sb
          .from('characters')
          .select('id,name,race,character_class,level,campaign,image_url,image_thumb_url,npc_card')
          .not('npc_card','is',null)
          .order('created_at',{ascending:false})
          .limit(80);
        if(pool.error)throw pool.error;
        chars=pool.data||[];

        if(pending && Array.isArray(pending.memberIds) && pending.memberIds.length){
          /* Pool-filter path (Run Cast): restrict candidate pool to
             the user's saved cast, then let the size picker decide
             how many. */
          var idSet = {};
          pending.memberIds.forEach(function(id){ idSet[String(id)] = true; });
          var pinned = chars.filter(function(c){ return c && idSet[String(c.id)]; });
          if(pinned.length >= size){ chars = pinned; }
          window.__hohPendingPartyRun = null;
        } else if (typeof window.hohCastOnlyActive === 'function' && window.hohCastOnlyActive('company')){
          if (typeof window.hohFilterPoolCast === 'function'){
            var castFiltered = window.hohFilterPoolCast(chars);
            if (castFiltered && castFiltered.length >= size){ chars = castFiltered; }
          }
        }
      }
      /* Apply the "only my liked heroes" filter if the user toggled it on in
         the picker. Falls back to the full list if the user has not liked
         enough heroes to fill the requested size. */
      if (typeof window.hohLikedOnlyActive === 'function' && window.hohLikedOnlyActive('company')){
        if (typeof window.hohFilterPoolLiked === 'function'){
          var likedFiltered = window.hohFilterPoolLiked(chars);
          if (likedFiltered && likedFiltered.length >= size){ chars = likedFiltered; }
        }
      }
      if(chars.length<size){
        showError('The Hall needs a few more heroes before we can gather this many. Submit one, then try again.');
        return;
      }

      var picked=shuffle(chars.slice()).slice(0,size).map(function(c){
        return {
          id:c.id,
          name:c.name,
          race:c.race||'',
          character_class:c.character_class||'',
          level:c.level||null,
          campaign:c.campaign||'',
          /* Hearts is needed for the rarity tint on each member row in
             memberHtml. Without it every character defaults to common
             (0 hearts) and the rarity ladder never shows. */
          hearts:c.hearts||0,
          image_url:c.image_url||null,
          image_thumb_url:c.image_thumb_url||null
        };
      });

      /* Worker payload: strip image urls so prompt stays lean. */
      var workerChars=picked.map(function(p){
        return {
          id:p.id,
          name:p.name,
          race:p.race,
          character_class:p.character_class,
          level:p.level,
          campaign:p.campaign
        };
      });

      /* R43: custom-mode payload extension. The worker receives
         scenario.id="custom" plus three new fields the worker prompt
         can use:
           custom_prompt:  the situation the user typed (≤220 chars)
           custom_name:    optional company name suggestion (≤60)
           role_assignments: { hero_id: "their role" } for any heroes
                            the user pre-assigned. Empty strings are
                            kept so the worker knows which were left
                            open.
         The worker is responsible for incorporating these into its
         system prompt; we just deliver the payload faithfully. */
      var customPayload = window.__hohCustomPayload || null;
      var requestBody = {
        scenario:{id:scenario.id,label:scenario.label,vibe:scenario.vibe},
        characters:workerChars,
        party_size:size,
        /* R145-F: New "cinematic moment" mode. Tells the worker we
           want the output to read as a SCENE — what each character is
           doing RIGHT NOW, not just role descriptions. The worker is
           expected to:
             - Open with the scene already in motion (no "they will...")
             - For each member, include a `doing` field describing the
               micro-action they're physically performing at this exact
               second (gripping a hilt, glancing at the door, etc.)
             - Have `role` describe their function in the scene, NOT a
               static personality bio
             - Have `bond` describe a live tension WITH another named
               member, not a generic "they admire X"
             - End on a beat the DM can extend (someone speaks, a die
               rolls, a door opens) — keep dm_hook to 2 short sentences
           The format_hint string is passed verbatim into the worker's
           system prompt so the AI knows the rendering contract. */
        style: 'cinematic_moment',
        require_actions: true,
        format_hint:
          'For each company member return {display_name, role, bond, doing} where:' +
          ' role = their function in this scene in the present tense' +
          ' (e.g. "Holding the wagon door shut against the wind"),' +
          ' bond = a live tension with another named member (e.g. "Glaring at Ailuin' +
          ' who pulled the trigger first"),' +
          ' doing = the single micro-action they are performing right this second' +
          ' (e.g. "Thumbing the safety on their crossbow", "Counting coins under' +
          ' the table"). All three are short — under 22 words each.' +
          ' Open company.hook with the scene already in motion. Keep company.dm_hook' +
          ' to two sentences ending on a beat the DM can play (a door opens, dice' +
          ' clatter, a name is spoken). Do not narrate "they will" or "they would" —' +
          ' present tense only.'
      };
      if(customPayload){
        requestBody.custom_prompt = customPayload.custom_prompt || '';
        requestBody.custom_name = customPayload.custom_name || '';
        requestBody.role_assignments = customPayload.role_assignments || {};
        /* R63: relationships is a free-form text block the user wrote
           ("X owes Y money", "Z secretly admires W"). The worker
           prompt should weave these into the dynamic — they\'re the
           secret sauce that makes the output feel like the user\'s
           party specifically, not a generic NPC group. */
        requestBody.relationships = customPayload.relationships || '';
      }
      var resp=await fetch(COMPANY_WORKER_URL,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(requestBody)
      });

      if(!resp.ok){
        var txt=await resp.text().catch(function(){return '';});
        throw new Error('worker '+resp.status+(txt?' · '+txt.slice(0,120):''));
      }
      var data=await resp.json();
      if(!data||!data.success||!data.company)throw new Error(data&&data.error?data.error:'generation failed');

      stopLoadingMessages();
      bumpUsage();
      currentCompany=data.company;
      currentCharacters=picked;
      /* Header on result view: useful instead of redundant. The card
         below already shows the company name and hookline; the modal
         header says what to do ("tap a portrait to open").
         Jan (2026-09-27): results are no longer saved to Your Hall, so
         the header no longer says "Saved to your hall" and the auto-save
         after this render is gone. */
      setHeader(
        'THE DM\'S SATCHEL',
        (scenario && scenario.label) ? scenario.label : 'Company Ready',
        'Tap any portrait to open that hero. Gather another for a fresh dynamic.'
      );
      renderResult(data.company,picked);

      /* Bump usage counters for the raffle signal. Fire-and-forget. */
      try{
        sb.rpc('increment_table_use',{char_ids:picked.map(function(p){return String(p.id);})});
      }catch(e){/* no-op */}

    }catch(e){
      console.error('[Company]',e);
      stopLoadingMessages();
      showError('We couldn\'t gather that company. Give it another roll in a moment.');
    } finally {
      /* R43: clear the custom payload after EVERY attempt (success or
         error) so a subsequent preset run doesn\'t accidentally
         inherit the custom prompt. */
      window.__hohCustomPayload = null;
    }
  };

  /* ============ RESULT RENDER ============ */
  function memberHtml(m,picked){
    var src=null;
    if(m&&m.id){src=picked.find(function(p){return String(p.id)===String(m.id);});}
    if(!src&&typeof m.index==='number'&&picked[m.index])src=picked[m.index];
    if(!src)src=picked[0]||{};

    var name=m.display_name||src.name||'Unknown';
    var metaBits=[];
    if(src.race)metaBits.push(src.race);
    if(src.character_class)metaBits.push(src.character_class);
    if(src.level)metaBits.push('Lv '+src.level);
    var meta=metaBits.join(' · ');

    var role=neutralize(m.role||'');
    var bond=neutralize(m.bond||'');
    /* R145-F: New "doing" field — the micro-action the character is
       performing right this second in the scene. Renders above role/
       bond as a small italic line so the eye lands on the live moment
       before reading the supporting role/bond context. Graceful: if
       the worker hasn't sent it (older response shape), this is just
       an empty string and the line doesn't render. */
    var doing=neutralize(m.doing||'');

    var imgUrl=src.image_thumb_url||src.image_url||'';
    var avatar=imgUrl
      ? '<div class="hoh-company-member-avatar"><img src="'+esc(imgUrl)+'" alt="'+esc(name)+'" loading="lazy" crossorigin="anonymous"></div>'
      : '<div class="hoh-company-member-avatar"><div class="hoh-company-member-letter">'+esc(firstLetter(name))+'</div></div>';

    var href='?hero='+encodeURIComponent(src.slug||src.id); /* R319: pretty handle when the row carries one */
    /* Keep Company modal open underneath. Detail modal stacks on top via DOM order. */
    var clickAttr='onclick="event.preventDefault();hohOpenDetail(\''+esc(src.id)+'\');"';

    /* Rarity accent. The main file exposes hohGetRarity globally. If
       the gallery data has not populated yet we fall back to common. */
    var rarTier='common';
    try { if (typeof window.hohGetRarity==='function'){ rarTier=window.hohGetRarity(src.hearts||0).tier; } } catch(e){}

    return '<a class="hoh-company-member hoh-company-rar-'+rarTier+'" data-hero-id="'+esc(src.id)+'" href="'+esc(href)+'" '+clickAttr+'>'+
      avatar+
      '<div class="hoh-company-member-body">'+
        '<div class="hoh-company-member-name">'+esc(name)+'</div>'+
        (meta?'<div class="hoh-company-member-meta">'+esc(meta)+'</div>':'')+
        (doing?'<div class="hoh-company-member-doing">&#8250; '+esc(doing)+'</div>':'')+
        (role?'<div class="hoh-company-member-role"><span class="hoh-company-role-label">Role.</span>'+esc(role)+'</div>':'')+
        (bond?'<div class="hoh-company-member-role"><span class="hoh-company-role-label">Bond.</span>'+esc(bond)+'</div>':'')+
      '</div>'+
    '</a>';
  }

  function renderResult(company,picked){
    var body=$('hoh-company-result-body');
    if(!body)return;

    var members=Array.isArray(company.members)?company.members:[];
    var memberHtmlStr=members.map(function(m){return memberHtml(m,picked);}).join('');

    var hook=neutralize(company.hook||'');
    var dmHook=neutralize(company.dm_hook||company.dm_twist||'');
    var label=company.eyebrow||'The Company';
    var name=company.name||'A Company Without a Name';

    body.innerHTML=
      '<div class="hoh-company-card">'+
        '<div class="hoh-company-card-eyebrow">'+esc(label)+'</div>'+
        '<h3 class="hoh-company-card-name">'+esc(name)+'</h3>'+
        (hook?'<p class="hoh-company-card-hook">'+esc(hook)+'</p>':'')+

        '<div class="hoh-company-section-label">The Company</div>'+
        '<div class="hoh-company-members">'+memberHtmlStr+'</div>'+

        (dmHook?
          '<div class="hoh-company-dm-hook">'+
            '<div class="hoh-company-dm-hook-label">DM Hook</div>'+
            '<p class="hoh-company-dm-hook-text">'+esc(dmHook)+'</p>'+
          '</div>'
        :'')+
      '</div>';

    var btn=$('hoh-company-export-btn');
    if(btn){btn.disabled=false;btn.querySelector('span').textContent='Export PDF';}

    showView('result');
  }

  /* ============ PDF EXPORT ============ */
  /* Fetches each character image (crossOrigin) and returns
     dataURL + natural dimensions. Resolves to null on failure
     so the PDF layout can fall back to an initial block. */
  function loadImgForPdf(url){
    return new Promise(function(resolve){
      if(!url){resolve(null);return;}
      var img=new Image();
      img.crossOrigin='anonymous';
      img.onload=function(){
        try{
          var cv=document.createElement('canvas');
          var maxDim=400;
          var scale=Math.min(1,maxDim/Math.max(img.naturalWidth,img.naturalHeight));
          cv.width=Math.round(img.naturalWidth*scale);
          cv.height=Math.round(img.naturalHeight*scale);
          var ctx=cv.getContext('2d');
          ctx.drawImage(img,0,0,cv.width,cv.height);
          resolve({dataUrl:cv.toDataURL('image/jpeg',0.85),w:cv.width,h:cv.height});
        }catch(e){resolve(null);}
      };
      img.onerror=function(){resolve(null);};
      img.src=url;
    });
  }

  /* Wraps a string to a given width given a font size, using jsPDF
     splitTextToSize so every line fits the column exactly. */
  function wrap(doc,text,width){
    return doc.splitTextToSize(String(text||''),width);
  }

  window.hohCompanyExportPdf=async function(){
    if(!currentCompany||!currentCharacters){
      showError('Nothing to export yet.');
      return;
    }

    var btn=$('hoh-company-export-btn');
    if(btn){btn.disabled=true;btn.querySelector('span').textContent='Preparing...';}

    /* jsPDF is lazy-loaded on first export to keep ~250KB off the
       initial page download. The helper is exposed by hoh-section-
       core.js and is dedupe-safe across rapid clicks. If the load
       fails (offline, blocked CDN), surface the error and bail. */
    if(typeof window.hohEnsureJsPDF==='function'){
      try{await window.hohEnsureJsPDF();}
      catch(loadErr){
        if(btn){btn.disabled=false;btn.querySelector('span').textContent='Export PDF';}
        showError('PDF library failed to load. Check your connection and try again.');
        return;
      }
    } else if(!window.jspdf||!window.jspdf.jsPDF){
      if(btn){btn.disabled=false;btn.querySelector('span').textContent='Export PDF';}
      showError('PDF library failed to load. Refresh and try again.');
      return;
    }

    try{
      /* Preload all member images in parallel. */
      var images=await Promise.all(currentCharacters.map(function(c){
        return loadImgForPdf(c.image_thumb_url||c.image_url||null);
      }));

      var jsPDF=window.jspdf.jsPDF;
      var doc=new jsPDF({unit:'pt',format:'letter'});
      var pageW=doc.internal.pageSize.getWidth();
      var pageH=doc.internal.pageSize.getHeight();
      var marginX=54;
      var contentW=pageW-marginX*2;
      var y=60;

      /* === HEADER === */
      doc.setFont('helvetica','bold');
      doc.setFontSize(9);
      doc.setTextColor(175,105,140);
      doc.text((currentCompany.eyebrow||'The Company').toUpperCase(),pageW/2,y,{align:'center',charSpace:2});

      y+=24;
      doc.setFont('times','bold');
      doc.setFontSize(26);
      doc.setTextColor(30,25,40);
      var nameLines=wrap(doc,currentCompany.name||'A Company',contentW);
      nameLines.forEach(function(line){
        doc.text(line,pageW/2,y,{align:'center'});
        y+=28;
      });

      /* Divider */
      y+=4;
      doc.setDrawColor(175,105,140);
      doc.setLineWidth(0.8);
      doc.line(pageW/2-40,y,pageW/2+40,y);
      y+=22;

      /* === HOOK === */
      if(currentCompany.hook){
        doc.setFont('times','italic');
        doc.setFontSize(12);
        doc.setTextColor(70,60,80);
        var hookLines=wrap(doc,neutralize(currentCompany.hook),contentW);
        hookLines.forEach(function(line){
          doc.text(line,pageW/2,y,{align:'center',maxWidth:contentW});
          y+=16;
        });
        y+=10;
      }

      /* === THE COMPANY LABEL === */
      doc.setFont('helvetica','bold');
      doc.setFontSize(9);
      doc.setTextColor(175,105,140);
      doc.text('THE COMPANY',marginX,y,{charSpace:2});
      doc.setDrawColor(220,200,215);
      doc.setLineWidth(0.5);
      doc.line(marginX,y+4,pageW-marginX,y+4);
      y+=18;

      /* === MEMBERS === */
      var members=Array.isArray(currentCompany.members)?currentCompany.members:[];
      for(var i=0;i<members.length;i++){
        var m=members[i];
        var src=currentCharacters.find(function(p){return String(p.id)===String(m.id);})||currentCharacters[i]||{};
        var imgData=images[currentCharacters.indexOf(src)]||images[i]||null;

        var blockH=84;
        /* Page break check */
        if(y+blockH>pageH-100){
          doc.addPage();
          y=60;
        }

        var boxX=marginX;
        var boxW=contentW;
        var imgSize=60;
        var textX=boxX+imgSize+14;
        var textW=boxW-imgSize-14;

        /* Image or initial */
        if(imgData&&imgData.dataUrl){
          try{doc.addImage(imgData.dataUrl,'JPEG',boxX,y,imgSize,imgSize,undefined,'FAST');}catch(e){imgData=null;}
        }
        if(!imgData||!imgData.dataUrl){
          doc.setFillColor(246,232,240);
          doc.roundedRect(boxX,y,imgSize,imgSize,4,4,'F');
          doc.setFont('times','bold');
          doc.setFontSize(22);
          doc.setTextColor(175,105,140);
          doc.text(firstLetter(m.display_name||src.name),boxX+imgSize/2,y+imgSize/2+8,{align:'center'});
        }

        /* Name */
        doc.setFont('helvetica','bold');
        doc.setFontSize(13);
        doc.setTextColor(30,25,40);
        doc.text(String(m.display_name||src.name||'Unknown'),textX,y+13);

        /* Meta */
        var metaBits=[];
        if(src.race)metaBits.push(src.race);
        if(src.character_class)metaBits.push(src.character_class);
        if(src.level)metaBits.push('Lv '+src.level);
        if(metaBits.length){
          doc.setFont('times','italic');
          doc.setFontSize(10);
          doc.setTextColor(120,110,130);
          doc.text(metaBits.join('  \u00b7  '),textX,y+27);
        }

        /* R148-Z40: "Doing" line \u2014 the in-scene micro-action ("at the
           bar, hand on hilt"). Renders BEFORE Role/Bond as a short
           italic micro-line. The on-screen card shows this with a
           "\u203a" lead-in; the PDF uses an em-dash for printability.
           Page-break-safe: ry advances by the wrapped line height. */
        var ry=y+40;
        var doingText = neutralize(m.doing || '');
        if(doingText){
          doc.setFont('times','italic');
          doc.setFontSize(10);
          doc.setTextColor(140,90,120);
          var doingLines=wrap(doc, '\u2014 ' + doingText, textW);
          doc.text(doingLines,textX,ry);
          ry+=Math.max(12,doingLines.length*12)+2;
        }

        /* Role */
        if(m.role){
          doc.setFont('helvetica','bold');
          doc.setFontSize(8);
          doc.setTextColor(175,105,140);
          doc.text('ROLE',textX,ry,{charSpace:1.5});
          doc.setFont('times','normal');
          doc.setFontSize(10.5);
          doc.setTextColor(50,45,60);
          var roleLines=wrap(doc,neutralize(m.role),textW-34);
          doc.text(roleLines,textX+34,ry);
          ry+=Math.max(12,roleLines.length*12);
        }

        /* Bond */
        if(m.bond){
          doc.setFont('helvetica','bold');
          doc.setFontSize(8);
          doc.setTextColor(175,105,140);
          doc.text('BOND',textX,ry,{charSpace:1.5});
          doc.setFont('times','normal');
          doc.setFontSize(10.5);
          doc.setTextColor(50,45,60);
          var bondLines=wrap(doc,neutralize(m.bond),textW-34);
          doc.text(bondLines,textX+34,ry);
          ry+=Math.max(12,bondLines.length*12);
        }

        var usedH=Math.max(imgSize,ry-y);
        y+=usedH+18;
      }

      /* === DM HOOK === */
      if(currentCompany.dm_hook){
        /* Measure and page-break if needed */
        doc.setFont('times','italic');
        doc.setFontSize(11.5);
        var dmLines=wrap(doc,neutralize(currentCompany.dm_hook),contentW-28);
        var dmBoxH=22+dmLines.length*14+14;
        if(y+dmBoxH>pageH-60){
          doc.addPage();
          y=60;
        }
        doc.setFillColor(250,242,246);
        doc.roundedRect(marginX,y,contentW,dmBoxH,6,6,'F');
        doc.setDrawColor(175,105,140);
        doc.setLineWidth(2.5);
        doc.line(marginX,y,marginX,y+dmBoxH);

        doc.setFont('helvetica','bold');
        doc.setFontSize(9);
        doc.setTextColor(175,105,140);
        doc.text('DM HOOK',marginX+14,y+16,{charSpace:2});

        doc.setFont('times','italic');
        doc.setFontSize(11.5);
        doc.setTextColor(50,45,60);
        doc.text(dmLines,marginX+14,y+32);
        y+=dmBoxH+10;
      }

      /* === FOOTER === */
      var totalPages=doc.internal.getNumberOfPages();
      for(var p=1;p<=totalPages;p++){
        doc.setPage(p);
        doc.setFont('helvetica','normal');
        doc.setFontSize(8);
        doc.setTextColor(150,140,160);
        doc.text('The Hall of Heroes  ·  framedfantasy.com',pageW/2,pageH-32,{align:'center'});
        doc.setFontSize(7);
        doc.text('Page '+p+' of '+totalPages,pageW-marginX,pageH-32,{align:'right'});
      }

      var filename=(currentCompany.name||'the-company').replace(/[^a-z0-9]+/gi,'-').replace(/^-+|-+$/g,'').toLowerCase()+'.pdf';
      doc.save(filename);

    }catch(e){
      console.error('[Company PDF]',e);
      alert('Sorry, the PDF could not be generated. Try again in a moment.');
    }finally{
      if(btn){btn.disabled=false;btn.querySelector('span').textContent='Export PDF';}
    }
  };

})();
